import {Component, OnInit} from '@angular/core';
import {OdmoriService} from '../../odmori.service';
import {ToastrService} from 'ngx-toastr';
import {MyModalService} from '../modal.service';

@Component({
  selector: 'used-days',
  templateUrl: './usedDays.modal.html',
  styleUrls: ['./usedDays.modal.css']
})

export class UsedDaysModal implements OnInit  {

  absenceDaysByYear = {};
  isLoading: boolean;

  constructor(private odmoriService: OdmoriService, private toastr: ToastrService, private myModalService: MyModalService) {} 

  ngOnInit() {
    this.isLoading = true;
    this.countNumberOfUsedDays();
  };

  countNumberOfUsedDays() {
    this.odmoriService.countNumberOfUsedDays().subscribe(response => {
       this.isLoading = false;

        if (response.type == 'success') {
            this.absenceDaysByYear = response.data;

            return;
        };

        this.toastr.error('Došlo je do greške prilikom vraćanja podataka. Molimo vas da se obratite korisničkoj podršci.');
    });
  };

  closeModalUsedDays() {
    this.myModalService.closeModalUsedDays();
  };

}